import { Component } from '@angular/core';

@Component({
    selector: 'app-sprintpay-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent {
    constructor() {}
}
